import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchChallenge(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/courses/${id}`
  );

  return data;
}
